export const notNil = t => t !== null && t !== undefined;
export const isFn = t => typeof t === "function";
export const isString = t => typeof t === "string";
export const isNonEmptyString = t => isString(t) && t.trim().length > 0;
export const isNonEmptyArray = t => notNil(t) && t.length > 0;
